import {
   ConfidentialResource,
   ConfidentialResourceAccessRequest,
} from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

export type ConfidentialResourceAccessRequestPending = ConfidentialResourceAccessRequest & {
   requestStatus: 'PENDING';
   confidentialResources: [ConfidentialResource];
};

export type ConfidentialResourceAccessRequestAccepted = ConfidentialResourceAccessRequest & {
   requestStatus: 'ACCEPTED';
};

export const isConfidentialResourceAccessRequestPending = (
   request: ConfidentialResourceAccessRequest
): request is ConfidentialResourceAccessRequestPending => {
   return request.requestStatus === 'PENDING' && request.confidentialResources.length === 1;
};

export const isConfidentialResourceAccessRequestAccepted = (
   request: ConfidentialResourceAccessRequest
): request is ConfidentialResourceAccessRequestAccepted => {
   return request.requestStatus === 'ACCEPTED';
};
